import { useCallback, useEffect, useState } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

const GalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 0;
  margin: 0 auto;
  position: relative;
  margin-bottom: 20px;
`;

const MainImage = styled.img`
  width: 100%;
  height: 600px;
  object-fit: cover;
  margin-bottom: 20px;

  @media (max-width: 800px) {
    height: 400px;
  }
`;

const ThumbnailsContainer = styled.div`
  width: 100%;
  margin-top: 10px;
`;

const Thumbnail = styled.img<{ isSelected: boolean }>`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
  border: ${({ isSelected }) => (isSelected ? '1px solid #e5007d' : '1px solid gray')};
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.7)};
  &:hover {
    opacity: 1;
  }
`;

const SliderWrapper = styled.div`
  width: 100%;
  /* min-width:0 defuses the flexbox min-width:auto trap so overflow:hidden can
     clip react-slick's wide track if an ancestor is a flex container. */
  min-width: 0;
  position: relative;
  overflow: hidden;

  .slick-list {
    overflow: hidden;
  }

  .slick-slide {
    padding-right: 20px;
    transition: all 0.3s ease;
  }

  .slick-track {
    display: flex;
  }
`;

export const ImageSlider = ({ projectImages }: { projectImages: string[] }) => {
  const [selectedImage, setSelectedImage] = useState(projectImages[0]);

  useEffect(() => {
    handleSelectImage(projectImages[0]);
  }, [projectImages]);

  const handleSelectImage = useCallback((image: string) => {
    setSelectedImage(image);
  }, []);

  const slidesToShow = projectImages.length > 5 ? 10 : projectImages.length;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <GalleryContainer>
      <MainImage src={selectedImage} alt="Main" />
      <ThumbnailsContainer>
        <SliderWrapper>
          <Slider {...settings}>
            {projectImages.map((image, index) => (
              <Thumbnail
                key={index}
                src={image}
                alt={`Thumbnail ${index + 1}`}
                onClick={() => setSelectedImage(image)}
                isSelected={!!(image === selectedImage)}
              />
            ))}
          </Slider>
        </SliderWrapper>
      </ThumbnailsContainer>
    </GalleryContainer>
  );
};
